if (!daz) {
    var daz = {};
}
if (!daz.nfpets) {
    daz.nfpets = {};
}

daz.nfpets.mint = (function (nfpAddress) {

    let nfp = null;
    let myNFPs = [];
    const storage = window.localStorage;

    const init = function () {
        nfp = new DazContract721(nfpAddress, {
            name: "NFP",
            image: "",
            thumb: "",
        })
    }

    const getAllNfps = async function () {
        init();
        if (myNFPs.length === 0) {
            myNFPs = await nfp.getMyTokenIDs(dazethutil.me())
        }
        return myNFPs;
    }

    const getNfpsForMint = async function () {
        return getAllNfps().then(async tokens => {
            return daz.nfpets.sparky.NfpsAllowed(tokens).then(async sTokens => {
                return daz.nfpets.superSparky.NfpsAllowed(sTokens);
            })
        });
    }

    const getSigningMessage = function (tokens, wallet, nonce) {
        const msg = `Signing this message will allow you to access\ndownloads and submit updates to the NFPs on\nyour dashboard. It will not trigger a blockchain\ntransaction or cost any gas fees.\n\nYour NFP Collection: ${tokens}\n\nWallet: ${wallet}\n\nNonce: ${nonce}`;
        const hash = dazethutil.hash([msg]);
        return {
            text: msg,
            hash: hash
        }
    }

    const getSignature = async function (allowSigning) {
        const tokens = await getAllNfps();
        const tokenStr = tokens.join(', ');
        const nonce = Date.now();
        let signatureData = await storage.getItem(dazethutil.me() + "_signatureData");
        let data = false;
        let msg = null;

        if (tokens.length === 0) {
            throw "no nfp";
        }

        if (signatureData) {
            try {
                data = JSON.parse(signatureData);
                if (Math.floor((nonce - data.Nonce) / 1000) < 2592000) {
                    msg = getSigningMessage(tokenStr    , dazethutil.me(), data.Nonce);
                    if (data.SigHash && data.SigHash === msg.hash) {
                        return data
                    }
                }
            } catch (e) {
                data = false;
            }
        }

        if (!allowSigning) {
            return false;
        }

        try {
            msg = getSigningMessage(tokenStr, dazethutil.me(), nonce);
            const sig = await dazeth.web3.eth.personal.sign(msg.text, dazethutil.me()).then(r => r, error => {
                console.error(error);
            });
            if (nonce && sig) {
                data = {};
                data.Signature = sig;
                data.SigHash = msg.hash;
                data.Tokens = tokenStr;
                data.Nonce = nonce;
            } else {
                throw "signature failed"
            }
        } catch (e) {
            return false;
        }
        if (data === false) {
            storage.removeItem(dazethutil.me() + "_signatureData");
        } else {
            storage.setItem(dazethutil.me() + "_signatureData", JSON.stringify(data));
        }
        return data;
    }

    return {
        GetNFPs: getAllNfps,
        GetNfpsForMint: getNfpsForMint,
        Sign: getSignature,
    }
})(window.nfpetsConfig.pets.nfp);
